import * as React from 'react';
import './style/index.scss';
import { ContactUsFormContent } from './ContactUsFormContent';
import { SubmissionSuccessForm } from './SubmissionSuccessForm';
import { ContactUsFormProps } from './types/ContactUsFormProps';

interface ContactUsFormWrapperState {
    ticketId: Nullable<number>;
    isSubmissionSuccess: Nullable<boolean>;
    key: number;
}

export class ContactUsFormWrapper extends React.Component<ContactUsFormProps, ContactUsFormWrapperState> {
    constructor(props: ContactUsFormProps) {
        super(props);

        this.onSubmissionCallBack = this.onSubmissionCallBack.bind(this);
        this.onClickNewRequest = this.onClickNewRequest.bind(this);
        this.state = {
            ticketId: null,
            isSubmissionSuccess: null,
            key: 0
        };
    }
    render(): React.ReactNode {
        return (
          <React.Fragment>
                 {this.state.isSubmissionSuccess === null
                  && this.state.ticketId === null
                  && (
                      <ContactUsFormContent
                        productName={this.props.productName}
                        pageSource={this.props.pageSource}
                        onSubmitFn={this.props.onSubmitFn}
                        onClose={this.props.onClose}
                        onSubmissionCallBack={this.onSubmissionCallBack}
                        articles={this.props.articles}
                        initialSearchTerms={this.props.initialSearchTerms}
                        isVisible={this.props.isVisible}
                        searchTermCallBack={this.props.searchTermCallBack}
                        goToArticle={this.props.goToArticle}
                        key={this.state.key}
                        showCaseDeflection={this.props.showCaseDeflection}
                      />
                  )
                }
                {
                    this.state.isSubmissionSuccess &&
                    this.state.ticketId &&
                    <SubmissionSuccessForm ticketId={this.state.ticketId} onClickNewRequest={this.onClickNewRequest} />
                }
            </React.Fragment>
        );
    }

    onSubmissionCallBack = (ticketId: Nullable<number>, isSubmissionSuccess: boolean) => {
        this.setState({ticketId, isSubmissionSuccess});
    }

    onClickNewRequest = () => {
        this.setState({ ticketId: null, isSubmissionSuccess: null, key: this.state.key + 1});
    }
}